import { forwardRef } from 'react'
import useDelayUnmount from '../../Hooks/useDelayUnmount'
import { BackdropProps } from './props'
import { StyledBackdrop } from './styles'

const Backdrop = forwardRef<HTMLDivElement, BackdropProps>(
    ({ open = false, ...props }, ref) => {
        const shouldRender = useDelayUnmount(open, 300)

        return shouldRender ? (
            <StyledBackdrop {...props} isOpen={open} ref={ref} />
        ) : (
            <></>
        )
    }
)

Backdrop.displayName = 'Backdrop'

export default Backdrop

export { StyledBackdrop }
